<div
	class="loading-ellipsis"
	style.height="{{ dotSizePx() }}px"
	style.opacity="{{ dotOpacity() }}"
	style.width="{{ dotSizePx() * scale }}px"
>
	@for (value of interval; track value) {
		<div
			style.height="{{ dotSizePx() }}px"
			style.width="{{ dotSizePx() }}px"
			[attr.ada-background-color]="dotColor()"
			[style.left]="value === 3 ? 'calc(50% - ' + dotSizePx() / 2 + 'px)' : null"
		></div>
	}
</div>
